module.exports = __webpack_public_path__ + "img/CryingFace.3a024bc9.svg";